import { DeviceDetailsContext } from "@/Components/BifrostPageComponent/DeviceComponents/DeviceDetailsComponent/DeviceDetailsComponent"
import { BifrostLoader } from "@/Components/elements"
import { useContext } from "react"
import { Feed } from "semantic-ui-react"
import ConfigureEthernetSettingsModal from "../../SettingSegments/ConfigureEthernetSettings/ConfigureEthernetSettingsModal"

/**
 * Device IP Address component
 * @returns {JSX.Element} If the device is online, it will display the IP address; otherwise, it will show a message indicating that the device is offline.
 */
const DeviceIPAddress = () => {
	const { unitConfig } = useContext(DeviceDetailsContext)
	const { data, isFetching } = unitConfig.unitConfigData

	const deviceIP = data?.network?.Ethernet?.net_configuration?.address || "0.0.0.0"
	return (
		<Feed.Content>
			<Feed.Summary content={"Device IP Address:"} />
			<Feed.Extra text className={"device-change-disabled"} style={{ justifyContent: "space-between" }}>
				<BifrostLoader backgroundColor="white" inverted size="small" height="40px" minHeight="20px" isLoading={isFetching} style={{ marginLeft: "10px" }}>
					<span>{deviceIP}</span>
				</BifrostLoader>
			</Feed.Extra>
			<Feed.Extra text content={<ConfigureEthernetSettingsModal />} />
		</Feed.Content>
	)
}

export default DeviceIPAddress
